<template>
  <el-dialog
    :before-close="fechar"
    :visible.sync="visibility"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="60%">
      <span slot="title">
        <font-awesome-icon icon="user" />
        Selecionar Usuário 
      </span>

      <el-form size="mini" label-position="top" @submit.native.prevent>
        <el-row>
          <el-col>
            <el-form-item label="Nome">
              <el-autocomplete
                v-model="usuarioPesquisa.nome"
                :fetch-suggestions="nomeInputHandler"
                :debounce="1000"
                clearable
                @clear="limparNomeUsuarioPesquisaHandler"
                :trigger-on-focus="false"
                :hide-loading="true"
                popper-class="invisible-autocomplete-popper"
                style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" justify="end">
        <h4 style="color: #606266; margin: 0px 15px 5px 0px">{{ this.labelQuantidade }}</h4>
      </el-row>
      <el-table
        :data="usuarios"
        highlight-current-row
        @current-change="selecaoLinhaHandler"
        @row-dblclick="cliqueDuploLinhaHandler"
        empty-text="Nenhum Usuário encontrado"
        height="250"
        stripe
      >
        <el-table-column
          prop="nome"
          label="Nome"
          sortable
          show-overflow-tooltip
        />

        <el-table-column
          prop="cpf"
          label="CPF"
          sortable
          width="180"
          show-overflow-tooltip
        />

        <el-table-column
          prop="creci"
          label="CRECI"
          sortable
          width="150"
          show-overflow-tooltip
        />

        <infinite-loading
          :identifier="infiniteLoadingId"
          @infinite="pesquisar"
          slot="append"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more" />
          <div slot="no-results" />
        </infinite-loading>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="selecionarUsuarioHandler"
          type="success"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-check" />
          Selecionar 
        </el-button>

        <el-button
          @click="fechar"
          type="danger"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-close" />
          Fechar
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      infiniteLoadingId: 0,
      linhaSelecionada: undefined
    }
  },
  watch: {
    'usuarioPesquisa.nome': function(newValue) {
      if(newValue === "") { this.dispararPesquisa() }
    }
  },
  computed: {
    ...mapState('logsAcessoStore', {
      usuarios(state) { return state.listaUsuarios },
      usuarioPesquisa(state) { return state.usuarioPesquisa },
      labelQuantidade(state) { return state.labelQuantidadeUsuarios },
      logPesquisa(state) { return state.logPesquisa }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('logsAcessoStore', [
      'listarUsuarios',
      'limparUsuariosListados',
      'limparUsuarioPesquisa'
    ]),
    fechar() {
      this.linhaSelecionada = undefined;
      this.limparUsuarioPesquisa();
      this.listarUsuarios(this.usuarioPesquisa).then(() => {});
      this.$emit('close');
    },
    pesquisar($state) {
      if(this.usuarioPesquisa.pagina === 0) { this.showLoading(); }
      this.listarUsuarios(this.usuarioPesquisa)
        .then((resultado) => {
          if(this.usuarioPesquisa.pagina === 0) { this.hideLoading(); }
          if(resultado.lista.length === 100) {
            this.usuarioPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.usuarioPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.usuarioPesquisa.pagina === 0) { this.hideLoading(); }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    dispararPesquisa() {
      this.usuarioPesquisa.pagina = 0;
      this.limparUsuariosListados();
      this.infiniteLoadingId += 1;
    },
    nomeInputHandler(value) {
      this.usuarioPesquisa.nome = value;
      this.dispararPesquisa();
    },
    selecaoLinhaHandler(currentRow) {
      this.linhaSelecionada = currentRow;
    },
    selecionarUsuarioHandler() {
      if(!this.linhaSelecionada) {
        this.$message.warning("Selecione um Usuário na tabela");
        return;
      }
      this.logPesquisa.usuario = this.linhaSelecionada;
      this.fechar();
    },
    cliqueDuploLinhaHandler(row) {
      this.logPesquisa.usuario = row;
      this.fechar();
    },
    limparNomeUsuarioPesquisaHandler() {
      this.dispararPesquisa();
    }
  }
}
</script>